import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "@api/base-services-axios-rtx";
import { SectorProposalsEndpoints } from "@/shared/models/endpoints/sector-proposals.endpoint";

export interface SectorProposalPayload {
  name: string;
  city_id: number | string;
  latitude: number | string;
  longitude: number | string;
}

export const SectorProposalsQueryServices = createApi({
  reducerPath: "sector-proposals-services",
  baseQuery: axiosBaseQuery(),
  endpoints: builder => ({
    listSectorProposals: builder.mutation({
      query: (params?: Record<string, any>) => ({
        url: SectorProposalsEndpoints.list,
        method: "GET",
        params: params || {}
      })
    }),
    getSectorProposal: builder.mutation({
      query: ({ proposal }: { proposal: string | number }) => ({
        url: SectorProposalsEndpoints.detail(proposal),
        method: "GET"
      })
    }),
    createSectorProposal: builder.mutation({
      query: ({ body }: { body: SectorProposalPayload }) => ({
        url: SectorProposalsEndpoints.create,
        method: "POST",
        body
      })
    }),
    approveSectorProposal: builder.mutation({
      query: ({ proposal }: { proposal: string | number }) => ({
        url: SectorProposalsEndpoints.approve(proposal),
        method: "POST",
        params: { _method: "PUT" }
      })
    }),
    rejectSectorProposal: builder.mutation({
      query: ({ proposal, body }: { proposal: string | number; body: { comment: string } }) => ({
        url: SectorProposalsEndpoints.reject(proposal),
        method: "POST",
        params: { _method: "PUT" },
        body
      })
    })
  })
});

export const {
  useListSectorProposalsMutation,
  useGetSectorProposalMutation,
  useCreateSectorProposalMutation,
  useApproveSectorProposalMutation,
  useRejectSectorProposalMutation
} = SectorProposalsQueryServices;
